import { companyApis } from '@apis/dashboard/companyApis';
import { useQuery } from '@hooks/useQuery';

export const useCompanyMemberNo = (id: number) => {
  return useQuery([`/dashboard/company/${id}/member-no/`], () =>
    companyApis
      .get('/dashboard/company/{id}/member-no/', {
        path: { id },
      })
      .then((r) => r[200]!),
  );
};
